import { render, staticRenderFns } from "./CodigosEquiv.vue?vue&type=template&id=088bdb24&scoped=true&"
import script from "./CodigosEquiv.vue?vue&type=script&lang=js&"
export * from "./CodigosEquiv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../bym/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088bdb24",
  null
  
)

export default component.exports